
let paginationButtonClick = (button) => (event) => {
  event.preventDefault();
  const page = button.getAttribute("data-page")
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.set('pagination[page]', page)
  window.location.href = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + searchParams.toString();
}

let paginationLimitClick = (button) => (event) => {
  event.preventDefault();
  const limit = button.getAttribute("data-limit")
  let searchParams = new URLSearchParams(window.location.search);
  searchParams.set('pagination[limit]', limit)

  if( searchParams.has('pagination[page]') ) {
    searchParams.delete('pagination[page]')
  }

  window.location.href = window.location.protocol + "//" + window.location.host + "" + window.location.pathname + '?' + searchParams.toString();
}

/**
 * @param {string} buttonNext
 * @param {string} buttonPrev
 * @param {string} buttonLimit
 * @param {string} position
 */

export default (
  buttonNext,
  buttonPrev,
  buttonLimit,
  position
) => {

  const wrap = document.querySelector(position)
  if (!wrap) {
    return
  }

  const buttonNextElement = wrap.querySelector(buttonNext)
  if (!buttonNextElement) {
    return
  }

  const buttonPrevElement = wrap.querySelector(buttonPrev)
  if (!buttonPrevElement) {
    return
  }

  const limitItems = wrap.querySelectorAll(buttonLimit)
  limitItems.forEach((item) => {
    item.addEventListener('click', paginationLimitClick(item))
  })

  buttonNextElement.addEventListener('click', paginationButtonClick(buttonNextElement))
  buttonPrevElement.addEventListener('click', paginationButtonClick(buttonPrevElement))
}

